(() => {
  const root = document.querySelector('[data-ra-root]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const config = JSON.parse(root.querySelector('[data-ra-config]').textContent);
  const section = root.dataset.section;
  const scope = document.getElementById('ProductInfo-' + section);
  const form = document.getElementById('product-form-' + section);
  if (!scope || !form) return;
  const money = new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency});
  const update = () => {
    const id = form.querySelector('[name="id"]')?.value;
    const variant = config.variants.find(v => String(v.id) === String(id));
    if (!variant) return;
    const row = config.chart.find(r => r[0] === variant.size);
    const selected = root.querySelector('[data-ra-selected]');
    if (row) selected.textContent = `${config.selectedLabel} ${row[0]}: ${config.backLabel.toLowerCase()} ${row[1]} cm · ${config.chestLabel.toLowerCase()} ${row[3]} cm`;
    root.querySelectorAll('[data-ra-size]').forEach(el => el.setAttribute('aria-current',String(el.dataset.raSize === variant.size)));
    const button = document.getElementById('ProductSubmitButton-' + section);
    if (!button || button.disabled || button.classList.contains('loading')) return;
    const label = button.querySelector('span');
    const qty = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const discount = qty >= 3 ? .20 : qty === 2 ? .10 : 0;
    const text = `${config.addLabel} - ${money.format(variant.price / 100 * qty * (1-discount))}`;
    if (label && label.textContent.trim() !== text) label.textContent = text;
  };
  document.addEventListener('change', e => {if(scope.contains(e.target)) {update();setTimeout(update,100);}});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {if(event.data.sectionId === section) update();});
  }
  const button = document.getElementById('ProductSubmitButton-' + section);
  if(button) new MutationObserver(update).observe(button,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','class']});
  update();
})();
